import ListingEnergyCertificateModalInfoRow from './ListingEnergyCertificateModalInfoRow';

export default ListingEnergyCertificateModalInfoRow;
